import {BrowseCourse} from '@udemy/browse-course';
import {udSentry} from '@udemy/sentry';
import {udApi} from '@udemy/ud-api';

/**
 * Fetches course data for the given course IDs
 * @param courseIds - Array of course IDs to fetch
 * @param additionalFields - Optional array of additional fields to include
 * @returns Promise resolving to an array of course data
 */
export const getCoursesData = async (courseIds: number[], additionalFields: string[] = []) => {
    const courseFields = [
        '@default',
        'badges',
        'bestseller_badge_content',
        'buyable_object_type',
        'content_info',
        'content_info_short',
        'content_length_practice_test_questions',
        'free_course_subscribe_url',
        'headline',
        'image_50x50',
        'image_100x100',
        'image_304x171',
        'image_750x422',
        'instructional_level',
        'instructional_level_simple',
        'is_coding_exercises_badge_eligible',
        'is_in_personal_plan_collection',
        'is_recently_published',
        'last_update_date',
        'learn_url',
        'num_published_lectures',
        'num_published_practice_tests',
        'num_reviews',
        'published_time',
        'rating',
        'num_subscribers',
        'is_user_subscribed',
    ];
    const courseFieldsString = [...courseFields, ...additionalFields].join();
    const urls = courseIds.map((id) => {
        return `/courses/${id}/?fields[course]=${courseFieldsString}`;
    });

    // Resolve upstream requests
    return Promise.all(
        urls.map(async (url) => {
            try {
                const response = await udApi.get<BrowseCourse | undefined>(url);
                return response.data;
            } catch (e) {
                udSentry.captureException(e);
                return {};
            }
        }),
    );
};
